import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";

export default function HotSidebar() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            本周<span className="text-primary-500">热搜</span>榜
          </h2>
          <p className="text-foreground-500 text-sm">阅读量最高的吃瓜内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 bg-background-50 rounded-lg p-4 hover:bg-background-50/80 transition-colors border border-background-200/70"
            >
              <span
                className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                  idx === 0
                    ? "bg-primary-500 text-white"
                    : idx === 1
                    ? "bg-accent-500 text-white"
                    : idx === 2
                    ? "bg-secondary-500 text-white"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {idx + 1}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 mb-1 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span>{article.categoryName}</span>
                  <span>·</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}